import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import SearchSuggestionSingle from "../../components/searchSuggestionSingle/searchSuggestionSingle.component";
import Spinner from "../../components/spinner/spinner.component";
import {
  selectMapSuggestionsIsLoading,
  selectMapSuggestions,
  selectMapSuggestionsShow,
} from "../../redux/map/map.selectors";
import { SearchSuggestionListStyled } from "./SearchSuggestionList.styles";

import { Animated } from "react-animated-css";

const SearchSuggestionList = ({
  selectMapSuggestions,
  inputValue,
  listIsloading,
  selectMapSuggestionsIsLoading,
  selectMapSuggestionsShow,

  setInputValue,
}) => {
  console.log(
    !(
      selectMapSuggestionsShow &&
      (listIsloading || selectMapSuggestionsIsLoading)
    )
  );
  // debugger;
  // console.log(selectMapSuggestionsIsLoading);
  console.log("inputValue", inputValue.length);
  // debugger;

  // const [state, setstate] = useState(false);
  return (
    <SearchSuggestionListStyled
      selectMapSuggestionsShow={selectMapSuggestionsShow}
    >
     
      {
        // selectMapSuggestionsShow ? (
        !(listIsloading || selectMapSuggestionsIsLoading) ? (
          <Animated
            animationIn="bounceInDown"
            animationOut="bounceOutUp"
            animationInDuration={900}
            animationOutDuration={500}
            isVisible={selectMapSuggestionsShow}
            className="animated"
          >
            {/* <div
            className="list-cont"
            // style={{ visibility: "visible", opacity: "1s" }}
          > */}
            {inputValue.length >= 3 &&
              selectMapSuggestions?.map(({ ...props }, index) => (
                <SearchSuggestionSingle
                  setInputValue={setInputValue}
                  key={index}
                  {...props}
                />
              ))}
            {/* </div> */}
          </Animated>
        ) : (
          <SearchSuggestionSingle>
            <Spinner />
          </SearchSuggestionSingle>
        )
        // ) : null
      }
    </SearchSuggestionListStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectMapSuggestions: selectMapSuggestions,

  selectMapSuggestionsIsLoading: selectMapSuggestionsIsLoading,

  selectMapSuggestionsShow: selectMapSuggestionsShow,
});

export default connect(mapStateToProps)(SearchSuggestionList);
